import { NgModule } from '@angular/core';
import { NgOptimizedImage, CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { ImgLoadingComponent } from './img-loading.component';

@NgModule({
    imports: [CommonModule, NgOptimizedImage, LazyLoadImageModule, ImgLoadingComponent],
  exports: [ImgLoadingComponent],
  declarations: [],
})
export class ImgLoadingModule {}
